module.exports = __webpack_public_path__ + "img/03-2-1banner.54eef0fd.png";